import MaterialSelector, { IMaterial } from 'components/MaterialSelector';
import { SectionTextWrapper } from 'styles/global.styles';

import React from 'react';
import styled from 'styled-components';

interface IMaterailSection {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onSelectionChange: (index: number, newValue: boolean) => void;
  otherWasteValue: string;
  onChangeOtherWaste: (event: string) => void;
  data: IMaterial[];
  disabled: boolean;
  validationError?: string;
}

const MaterialSection = (props: IMaterailSection): JSX.Element => {
  return (
    <Wrapper>
      <SectionTextWrapper
        sectionNumber={3}
        heading="Vilka material behöver ni hjälp att återvinna?"
        description="Nedan finner ni några vanligt förekommande material. Vi rekommenderar att ni sorterar minst fem fraktioner!"
      />

      <MaterialSelector
        data={props.data}
        onSelectionChange={props.onSelectionChange}
        onClick={props.onClick}
        otherWasteValue={props.otherWasteValue}
        onChangeOtherWaste={(event) => props.onChangeOtherWaste(event.target.value)}
        disabled={props.disabled}
        error={props.validationError}
      />
    </Wrapper>
  );
};

export default MaterialSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 2rem;
`;
